var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMydelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1758087518979,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 54448,
    width: 16,
    height: 16,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.093333 425.44m5.333334 0l64 0q5.333333 0 5.333333 5.333333l0 294.933334q0 5.333333-5.333333 5.333333l-64 0q-5.333333 0-5.333334-5.333333l0-294.933334q0-5.333333 5.333334-5.333333Z",
    "p-id": 54449
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M582.24 425.44m5.333333 0l64 0q5.333333 0 5.333334 5.333333l0 294.933334q0 5.333333-5.333334 5.333333l-64 0q-5.333333 0-5.333333-5.333333l0-294.933334q0-5.333333 5.333333-5.333333Z",
    "p-id": 54450
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M917.333333 244.533333a5.333333 5.333333 0 0 0-5.333333-5.333333H112a5.333333 5.333333 0 0 0-5.333333 5.333333v64a5.333333 5.333333 0 0 0 5.333333 5.333334h88.32a5.333333 5.333333 0 0 1 5.333333 5.333333V912a5.333333 5.333333 0 0 0 5.333334 5.333333h601.973333a5.333333 5.333333 0 0 0 5.333333-5.333333V319.2a5.333333 5.333333 0 0 1 5.333334-5.333333H912a5.333333 5.333333 0 0 0 5.333333-5.333334zM738.293333 842.666667H285.706667a5.333333 5.333333 0 0 1-5.333334-5.333334V319.2a5.333333 5.333333 0 0 1 5.333334-5.333333h452.586666a5.333333 5.333333 0 0 1 5.333334 5.333333V837.333333a5.333333 5.333333 0 0 1-5.333334 5.333334z",
    "p-id": 54451
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M320 106.666667m5.333333 0l373.333334 0q5.333333 0 5.333333 5.333333l0 64q0 5.333333-5.333333 5.333333l-373.333334 0q-5.333333 0-5.333333-5.333333l0-64q0-5.333333 5.333333-5.333333Z",
    "p-id": 54452
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMydelete);
export default __webpack_public_path__ + "static/media/mydelete.65f5e910.svg";
export { ForwardRef as ReactComponent };